import { useEffect } from "react";
import { StrategyVersionCard } from "./card";
import { StrategyVersionNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { StrategyVersionsTable } from "./table";

export default function StrategyVersions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Versions de stratégie");
  }, []);

  return (
    <Routes>
      <Route index element={<StrategyVersionsTable />} />
      <Route path="new" element={<StrategyVersionNew />} />
      <Route path=":id" element={<StrategyVersionCard />} />
    </Routes>
  );
}
